module.exports = __webpack_public_path__ + "img/raw-data-icon.5d05aeb4.png";